import React from "react";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import KnoaCardMainRow from "../CardParts/KnoaCardMainRow";
import LinkWithTooltip from "../../Common/LinkWithTooltip";

// ✅ Subcomponent: Footer Section
const StatCardFooter = ({ tooltip, stats, iconStatus }) => {
    if (!tooltip?.text && !stats?.text) return null;

    const statColorClass =
        stats?.dataDiff === "0"
            ? "text-gray-dark"
            : iconStatus === "success"
                ? "text-success"
                : "text-danger-home";

    const statIcon =
        stats?.dataDiff === "0"
            ? ""
            : stats?.dataDiff > 0
                ? "trending_up"
                : "trending_down";

    return (
        <div className="px-4 pb-3">
            <hr className="mt-0 mb-2" />
            <Row className="align-items-center">
                {tooltip?.text && (
                    <Col sm={4} className="text-start">
                        <LinkWithTooltip
                            tooltip={tooltip.text}
                            id={tooltip.key}
                            tooltipIconClass={tooltip.iconClass}
                            buttonStyle={tooltip.buttonStyle}
                            iconStyle={tooltip.iconStyle}
                            ariaLabel={tooltip.text}
                        />
                    </Col>
                )}
                {stats?.text && (
                    <Col sm={8} className="text-end">
                        <div className={`stats ${statColorClass}`}>
                            {statIcon && <i className="material-icons">{statIcon}</i>}&nbsp;
                            {stats.text}
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
};

// ✅ Main Component
const StatCard = ({
                      icon,
                      subHeading,
                      heading,
                      tooltip,
                      stats,
                      checkbox,
                      mainRowHeight
                  }) => {
    const hasLink = heading.linkPath && heading.cardId;

    const cardContent = (
        <div className="card shadow-sm mb-3">
            <div className="card-body px-4">
                {checkbox && <div className="mb-2">{checkbox}</div>}
                <KnoaCardMainRow
                    icon={icon}
                    subHeading={subHeading}
                    heading={heading}
                    mainRowHeight={mainRowHeight}
                />
            </div>
            <StatCardFooter tooltip={tooltip} stats={stats} iconStatus={icon.status} />
        </div>
    );

    return hasLink ? (
        <NavLink
            to={{
                pathname: heading.linkPath,
                state: { id: heading.cardId }
            }}
            className="nav-link"
            aria-label={tooltip?.text}
        >
            {cardContent}
        </NavLink>
    ) : (
        cardContent
    );
};

export default StatCard;